export const SHOPIFY_SF_API_VERSION = '2025-04';
export const BYPASS_GATING_FOR_DOMAINS = [
    '96ee72-3.myshopify.com',
    'walkerrose.myshopify.com',
];
// Shops on the Zendesk Messaging widget; all others stay on the Classic Chat widget.
export const ZENDESK_MESSAGING_DOMAINS = ['customergrowthdemo.myshopify.com'];
export const SHOP_INFO_KEY = Object.freeze({
    SKIP_POPCLIPC_CREATION_STEP: 'skippedFirstPopclipsCreation',
});
export const ACCEPTED_SHOP_INFO_KEYS = [
    SHOP_INFO_KEY.SKIP_POPCLIPC_CREATION_STEP,
];
